<template>
  <div class="container presentation-container">
    <div class="mb-4">
      <div class="w-100 px-5 py-2" style="background-color: #3281bc;">
        <img src="../../../public/assets/images/white-logo.png" alt="Logo">
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="strong mr-5">
          Thank you for submitting your application to OREP, we will review your application and send your Quote within two (2) business days.
          If you have any questions, please email <a target="_blank" href="mailto:info@orep.org" style="font-size: 20px; color: #3d85c6;">info@orep.org</a>
          or call <strong>888-347-5273</strong>.
        </h4>
        <img src="../../../public/assets/images/call.png" class="img-call" alt="Logo">
      </div>
    </div>
    <div class="mb-4 program-highlight">
      <h4>Program Highlights</h4>
      <ul>
        <li>"A" Rated, Admitted Carrier (AM Best Rating)</li>
        <li>$10,000 Disciplinary Proceedings Coverage</li>
        <li>Broad Coverage for Appraisers: Coverage for Residential, Commercial, Right of Way Appraisals</li>
        <li>Inexpensive Option to Add Trainee Coverage</li>
        <li>$25,000 Subpoena Assistance</li>
        <li>Loss of Earning: $500 a day, $10,000 maximum.</li>
        <li>AMC Extension Coverage Available</li>
        <li>FREE extended reporting period in case of disability/death</li>
        <li>FREE extended reporting period upon retirement (if an OREP policyholder for 5 years)</li>
        <li>OREP Serving Appraiser’s E&O Insurance Needs over 20 Years</li>
      </ul>
      <p class="strong mt-4">Why OREP</p>
      <ul>
        <li>14 Hours FREE CE for Appraisers (most states)</li>
        <li>Free State Board Complaint Consulting</li>
        <li>Free Risk Management and Claims Support</li>
        <li>Guaranteed Delivery of Working RE Magazine</li>
      </ul>
    </div>
    <div class="mb-4 footer">
      <p class="mt-3 strong">OREP</p>
      <p>6353 El Cajon Blvd, Suite 124-605</p>
      <p>San Diego, CA 92115 </p>
      <p>(888) 347-5273</p>
      <p>inspectors@OREP.org</p>
      <p>OREP Insurance Services, LLC. Calif. Lic. #0K99465</p>
    </div>
  </div>
</template>

<script>
  import $ from "jquery";

  export default {
    name: "group-appraiser-representation",
    computed: {
      groupAppraiser() {
        return this.$store.state.groupAppraiser.groupAppraiser;
      },
      state() {
        return this.$store.state.groupAppraiser;
      },
      errorMsg() {
        return this.$store.state.groupAppraiser.errorMsg;
      }
    },
    mounted() {
      $('html, body').animate({
          scrollTop: $('.presentation-container').offset().top
      }, 500);
    },
  }
</script>

<style scoped>
  .container {
    background-color: white !important;
    padding-bottom: 30px;
  }
  .img-call {
    height: 170px;
    max-height: 170px;
  }
  p {
    margin: 5px 0;
  }
  .strong {
      font-weight: bold !important;
  }
  table td {
    padding: 0 5px !important;
  }
  table > tbody > tr > td:first-child {
    width: 35%
  }
  table > tbody > tr > td:last-child {
    width: 65%
  }


  .table-bordered td {
    vertical-align: top;
    border-right: 2px solid #dee2e6;
    border-left-width: 0;
    border-bottom-width: 0;
    border-top-width: 0;
  }
</style>
